import ListTransferRequisitions from "../../../../components/@documents/transfer_requisitions/ListTransferRequisitions";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TransferRequisitionsPage() {

    return (
        <ListTransferRequisitions 
            routeType={routeTypes.retail}
        />
    )
}